import * as React from 'react'

import { cn } from '@/lib/utils'

export const Card = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('rounded-lg border border-card-border bg-card text-card-foreground', className)} {...props} />
)

export const CardHeader = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('space-y-1.5 p-4', className)} {...props} />
)

type CardTitleProps = React.HTMLAttributes<HTMLHeadingElement> & {
  children: React.ReactNode
}

export const CardTitle = ({ className, children, ...props }: CardTitleProps) => (
  <h3 className={cn('text-base font-semibold', className)} {...props}>
    {children}
  </h3>
)

export const CardContent = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('p-4 pt-0', className)} {...props} />
)
